<template>
  <div>
    <horizontal-navbar @search="searchAccounts"></horizontal-navbar>

    <breadcrumb-slot :items="items" :modal="false"></breadcrumb-slot>

    <div class="p-1 d-flex justify-content-between">
      <h2 class="text-dark">მომხმარებლები</h2>

      <b-button variant="primary" class="mb-3" @click="openModal">
        <feather-icon icon="PlusCircleIcon"
                      class="mr-50"/>
        <span class="align-middle">მომხმარებლის დამატება</span>
      </b-button>
    </div>

    <b-modal id="modal-edit"
             ref="my-modal"
             size="lg"
             class="p-3"
             hide-footer
             hide-header
             centered>

      <div class="pt-2 pb-2 modal-custom-header d-flex align-items-center justify-content-between">
        <h4 v-if="editing">მომხმარებლის რედაქტირება</h4>
        <h4 v-else>მომხმარებლის დამატება</h4>

        <b-button variant="flat-secondary" class="btn-icon mr-1" size="lg" @click="hideModal">
          <feather-icon icon="XIcon"/>
        </b-button>
      </div>

      <b-form class="edit-patient d-flex row justify-content-between">
        <b-form-group label="სახელი *"
                      label-for="name">
          <b-form-input id="name" v-model="name"
                        placeholder="სახელი"/>
        </b-form-group>

        <b-form-group label="პროფილის ტიპი *"
                      label-for="profileType">
          <b-form-select v-model="profileType"
                         :options="roleNames"/>
        </b-form-group>

        <b-form-group label="გვარი *"
                      label-for="surname">
          <b-form-input id="surname" v-model="surname"
                        placeholder="გვარი"/>
        </b-form-group>

        <b-form-group label="რეგიონი *" v-if="regions"
                      label-for="region">
          <b-form-select v-model="region"
                         :options="regions"/>
        </b-form-group>

        <b-form-group label="პირადი ნომერი *"
                      label-for="identityNumber">
          <b-form-input id="identityNumber" v-model="identityNumber"
                        :state="validate_identity_number"
                        placeholder="პირადი ნომერი"/>
          <b-form-invalid-feedback for="identityNumber">
            პირადი ნომერი უნდა იყოს 11 სიგრძის
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group :label="profileType !== 'admin' ? `დაწესებულება *` : ''" v-if="region_institutions"
                      label-for="institution">
          <b-form-select v-if="profileType !== 'admin'" v-model="institution" :disabled="region_institutions.length === 0"
                         :options="region_institutions"/>
        </b-form-group>

        <b-form-group label="ტელეფონის ნომერი *"
                      label-for="phone">
          <b-form-input id="phoneNumber" v-model="phone"
                        placeholder="ტელეფონის ნომერი"/>
        </b-form-group>

        <template v-if="!editing">
          <div class="divider my-2">
            <div class="divider-text">
              <strong>ავტორიზაციის მონაცემები</strong>
            </div>
          </div>

          <b-form-group label="ტელეფონის ნომერი *" v-if="false"
                        label-for="phone">
            <b-form-input id="phone_new" :disabled="editing !== null" v-model="phone"
                          placeholder="ტელეფონის ნომერი"/>
          </b-form-group>

          <b-form-group label="პაროლი *"
                        label-for="password">
            <b-form-input id="password" type="password" v-model="password"
                          :state="validate_password"
                          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                          placeholder="პაროლი"/>
            <b-form-invalid-feedback for="password">
              პაროლი უნდა იყოს მინიმუმ 8 სიგრძის. ასევე, უნდა შეიცავდეს დიდ და პატარა ასოებს და სიმბოლოებს
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="გაიმეორე პაროლი *"
                        label-for="confirmPassword">
            <b-form-input id="confirmPassword" type="password" v-model="confirmPassword"
                          :state="validate_confirm_password"
                          placeholder="გაიმეორე პაროლი"/>
            <b-form-invalid-feedback for="confirmPassword">
              პაროლები არ ემთხვევა ერთმანეთს
            </b-form-invalid-feedback>
          </b-form-group>
        </template>

      </b-form>

      <div class="mt-1 d-flex justify-content-between align-items-center">
        <div class="edit-buttons" v-if="editing">
          <b-button variant="flat-danger" class="mb-2" @click="warning(editing)">
            <feather-icon icon="Trash2Icon"
                          class="mr-50"/>
            <span class="align-middle">მომხმარებლის წაშლა</span>
          </b-button>
          <b-button variant="primary" class="mb-2" @click="updateAccount">
            <feather-icon icon="SaveIcon"
                          class="mr-50"/>
            <span class="align-middle">მომხმარებლის რედაქტირება</span>
          </b-button>
        </div>

        <b-button v-else variant="primary" :disabled="!isValid" class="save-changes mb-3"
                  @click="registerAccount">
          <feather-icon icon="SaveIcon"
                        class="mr-50"/>
          <span class="align-middle">მომხმარებლის დამატება</span>
        </b-button>

      </div>

      <b-form v-if="editing" class="edit-patient d-flex row justify-content-between">

        <div class="divider my-2">
          <div class="divider-text">
            <strong>ავტორიზაციის მონაცემები</strong>
          </div>
        </div>

        <b-form-group label="ტელეფონის ნომერი *" v-if="false"
                      label-for="phone">
          <b-form-input id="phone" :disabled="editing !== null" v-model="phone"
                        placeholder="ტელეფონის ნომერი"/>
        </b-form-group>

        <b-form-group label="პაროლი *"
                      label-for="password">
          <b-form-input id="reset_password" type="password" v-model="password"
                        :state="validate_password"
                        pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                        placeholder="პაროლი"/>
          <b-form-invalid-feedback for="password">
            პაროლი უნდა იყოს მინიმუმ 8 სიგრძის. ასევე, უნდა შეიცავდეს დიდ და პატარა ასოებს და სიმბოლოებს
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="გაიმეორე პაროლი *"
                      label-for="confirmPassword">
          <b-form-input id="reset_confirmPassword" type="password" v-model="confirmPassword"
                        :state="validate_confirm_password"
                        placeholder="გაიმეორე პაროლი"/>
          <b-form-invalid-feedback for="confirmPassword">
            პაროლები არ ემთხვევა ერთმანეთს
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group></b-form-group>

        <div class="mt-2 d-flex justify-content-between align-items-center">
          <b-button variant="primary" class="mb-3" :disabled="!validate_password || !validate_confirm_password" @click="changePassword">
            <feather-icon icon="SaveIcon"
                          class="mr-50"/>
            <span class="align-middle">პაროლის რესეტი</span>
          </b-button>
        </div>
      </b-form>

    </b-modal>

    <table-accounts v-if="accounts_meta"
                    :visible="tableVisible"
                    :rows="accounts.list"
                    :columns="columns"
                    :accounts_meta="accounts_meta"
                    :roles="roleNames"
                    paging="15"
                    @delete="warning"
                    @edit="editAccount"
                    @updateTable="getAccounts">
    </table-accounts>
  </div>
</template>

<script>
import TableAccounts from "../table/bs-table/TableAccounts";
import BreadcrumbSlot from "../components/breadcrumb/BreadcrumbSlot";
import {
  BButton,
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormInvalidFeedback
} from "bootstrap-vue";
import moduleAccounts from "../../store/accounts/moduleAccounts"
import moduleRegions from "../../store/regions/moduleRegions"
import moduleInstitutions from "../../store/institution/moduleInstitution"
import HorizontalNavbar from "../navbar/HorizontalNavbar";

const appLoading = document.getElementById("loading-bg")

export default {
  name: "Reports",
  components: {
    HorizontalNavbar,
    BreadcrumbSlot,
    TableAccounts,
    BButton,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormInvalidFeedback
  },

  data() {
    return {
      data: {},
      items: [
        {
          text: "მომხმარებლები",
          active: true
        }
      ],
      tableVisible: true,
      columns: [
        {
          key: "name",
          label: "სახელი",
          sortable: true
        },
        {
          key: "institution",
          label: "დაწესებულება",
          sortable: true
        },
        {
          key: "accountType",
          label: "ანგარიშის ტიპი",
          sortable: true,
        },
        {
          key: "date",
          label: "დამატების თარიღი",
          sortable: true
        },
        {
          key: "actions",
          label: "",
        },
      ],
      roleNames: [
        {value: "phthisiologist", text: "ფთიზიატრი"},
        {value: "epidemiologist", text: "ეპიდემიოლოგი"},
        {value: "admin", text: "ადმინი"},
      ],

      profileType: null,
      institution: null,
      region: null,
      editing: null,

      password: "",
      confirmPassword: "",
      old_password: "",
      phone: "",
      name: "",
      surname: "",
      identityNumber: "",
      userId: "",
    }
  },

  watch: {
    region: function (region) {
      this.institution = null;
      this.getRegionInstitutions({regionId: region});
    },
  },

  mounted() {
    if (!moduleAccounts.isRegistered) {
      this.$store.registerModule("accounts", moduleAccounts);
      moduleAccounts.isRegistered = true
    }
    if (!moduleRegions.isRegistered) {
      this.$store.registerModule("regions", moduleRegions);
      moduleRegions.isRegistered = true
    }
    if (!moduleInstitutions.isRegistered) {
      this.$store.registerModule("institutions", moduleInstitutions);
      moduleInstitutions.isRegistered = true
    }
    this.getRoles().then(() => {
      this.getAccounts({skip: 0}).then(() => {
        this.getRegions();
        if (appLoading) {
          appLoading.style.display = "none"
        }
      });
    });
  },

  computed: {
    roles() {
      return this.$store.state.accounts.roles
    },
    accounts() {
      return this.$store.state.accounts ? this.$store.state.accounts.accounts : []
    },
    editing_account() {
      return this.$store.state.accounts.account
    },
    accounts_meta() {
      if(this.$store.state.accounts) {return this.$store.state.accounts.accounts_meta}
      return null
    },
    validate_identity_number() {
      if (this.identityNumber.length === 0) {return null}
      return this.identityNumber.length === 11
    },
    validate_password() {
      if (this.password.length === 0) {return null}
      return this.password.length >= 8 && this.password.match("(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}")
    },
    validate_confirm_password() {
      return this.confirmPassword === this.password
    },
    regions() {
      if (this.$store.state.regions) {return this.$store.state.regions.regions;}
      return this.$store.state.regions
    },
    institutions() {
      return this.$store.state.institutions.institutions
    },
    region_institutions() {
      if (this.$store.state.regions) {return this.$store.state.regions.region_institutions;}
      return this.$store.state.regions
    },

    isValid() {
      return (this.password !== ""
          && this.password === this.confirmPassword)
          && this.identityNumber.length === 11
          && (this.profileType === "admin" || this.institution !== null)
    }
  },

  methods: {
    searchAccounts(searchWord) {
      this.getAccounts({searchWord: searchWord});
    },

    registerAccount() {
      let accountInfo = {
        firstName: this.name,
        lastName: this.surname,
        phoneNumber: this.phone,
        password: this.password,
        confirmPassword: this.confirmPassword,
        roleName: this.profileType,
        identityNumber: this.identityNumber,
        institutionId: this.institution,
        regionId: this.region,
      };
      this.tableVisible = false;
      return this.$store.dispatch("accounts/registerAccount", accountInfo).then(() => {
        this.getAccounts();
        this.tableVisible = true;
        this.resetModalData();
        this.hideModal();
      }).catch((err) => {
        alert(err.response.data);
      });
    },

    getRoles(payload = {}) {
      this.tableVisible = false;
      return this.$store.dispatch("accounts/getRoles", payload).then(() => {
        this.tableVisible = true;
      }).catch((err) => {
      });
    },

    getRegions(payload = {}) {
      // this.tableVisible = false;
      return this.$store.dispatch("regions/getRegions", payload).then(() => {
        // this.tableVisible = true;
      }).catch((err) => {
      });
    },

    getRegionInstitutions(payload = {}) {
      // this.tableVisible = false;
      return this.$store.dispatch("regions/getRegionInstitutions", payload).then(() => {
        // this.tableVisible = true;
        if (this.editing !== null) {this.institution = this.editing_account.institution.id}
      }).catch((err) => {
      });
    },

    getAccounts(payload = {}) {
      if (payload.selectedType && payload.selectedType !== "all") {
        let type = this.roles.find(a => a.name === payload.selectedType);
        payload["roles"] = [type.id];
      } else {
        payload["roles"] = [];
      }
      this.tableVisible = false;
      return this.$store.dispatch("accounts/getAccounts", payload).then((response) => {
        this.tableVisible = true;
        console.log('this.accounts_meta', this.accounts_meta)
      }).catch((err) => {
      });
    },

    getAccount(payload) {
      return this.$store.dispatch("accounts/getAccount", payload).then(() => {
      }).catch((err) => {
      });
    },

    updateAccount() {
      let payload = {
        id: this.editing_account.id,
        firstName: this.name,
        lastName: this.surname,
        identityNumber: this.identityNumber,
        roleId: this.roles.find(a => a.name === this.profileType).id,
        institutionId: this.institution,
        regionId: this.region,
        phoneNumber: this.phone,
      };
      return this.$store.dispatch("accounts/updateAccount", payload).then(() => {
        this.getAccounts();
        alert("მონაცემები წარმატებით შეიცვალა")
        // this.hideModal();
      }).catch((err) => {
        console.log("err.response.data", err)
        alert(err?.response?.data)
      });
    },

    changePassword() {
      let payload = {
        id: this.userId,
        username: this.phone,
        newPassword: this.password,
        confirmNewPassword: this.password
      };

      return this.$store.dispatch("accounts/resetPassword", payload).then(() => {
        alert("პაროლი წარმატებით შეიცვალა");
      }).catch((err) => {
        alert(err.response.data)
      });
    },

    deleteAccount(id) {
      this.$store.dispatch("accounts/deleteAccount", {id: id}).then(() => {
        this.getAccounts()
      }).catch((err) => {
      });
    },

    hideModal() {
      this.$refs["my-modal"].hide();
      this.editing = null;
      this.resetModalData();
    },

    openModal() {
      this.$refs["my-modal"].show();
      this.editing = null;
      this.resetModalData();
    },

    editAccount(account) {
      this.editing = account;
      this.$refs["my-modal"].show();
      this.getAccount({id: account.id}).then(() => {
        console.log("this.editing_account", this.editing_account)
        this.profileType = this.editing_account.roles[0];
        this.region = this.editing_account.institution?.regionId;
        this.phone = this.editing_account.phoneNumber;
        this.name = this.editing_account.firstName;
        this.surname = this.editing_account.lastName;
        this.identityNumber = this.editing_account.identityNumber;
        this.userId = account.id;
      });
    },

    warning(account) {
      this.$swal({
        title: "<span class=\"font-medium-1\">დარწმუნებული ხარ რომ გსურს წაშლა?</span>",
        icon: "warning",
        html:
            "<span class=\"font-small-3\">წაშლის შემდეგ ინფორმაციის აღდგენა შეუძლებელია</span>",
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "დიახ წაშალე",
        cancelButtonText: "გაუქმება",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((value) => {
        if (value.isConfirmed) {
          this.hideModal();
          this.deleteAccount(account.id)
        }
      });
    },

    resetModalData() {
      this.profileType = null;
      this.institution = null;
      this.region = null;
      this.editing = null;

      this.password = "";
      this.confirmPassword = "";
      this.old_password = "";
      this.phone = "";
      this.name = "";
      this.surname = "";
      this.identityNumber = "";
    }


  }
}
</script>

<style lang="scss">

.edit-patient {
  margin: 0 !important;

  .form-group {
    width: 45%;
  }
}

.modal-custom-header {
  h4 {
    white-space: nowrap;
    font-size: 20px;
  }
}

.divider {
  text-align: left;
  width: 100%;

  .divider-text {
    padding: 0 10px 0 0;
  }
}

.modal-body .save-changes {
  width: 100%;
}

.edit-buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  button {
    width: auto;
  }

}

.save-changes.btn span {
  font-size: 16px;
}

.form-group label {
  font-size: 1.057rem;
}

</style>
